import { useState, useEffect } from 'react';
import { API_CONFIG } from './../config'; 

const CREATE_USER_ENDPOINT = `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.USERBEFORELOGIN}`;

const UseUsersDataBeforeLogin = () => {
    const [allusers, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await fetch(CREATE_USER_ENDPOINT);
                if (!response.ok) throw new Error('Network response was not ok');
                
                const data = await response.json();
                if (data.success) {
                    setUsers(data.data || []);
                }
            } catch (err) {
                console.error("Fetch users error:", err);
            } finally {
                setLoading(false);
            }
        };
        fetchUsers();
    }, []);

    // Returning data and loading state just like your book example
    return { allusers, loading };
};

export default UseUsersDataBeforeLogin;